module.exports = __webpack_public_path__ + "img/google_translate.dd3c081d.png";